export interface Habit {
  id: string
  name: string
  identity: string
  cue: string
  frequency: 'daily'
  createdAt: string
  completions: string[] // YYYY-MM-DD format
}

const STORAGE_KEY = 'atomic-habits'

export const loadHabits = (): Habit[] => {
  try {
    const data = localStorage.getItem(STORAGE_KEY)
    return data ? JSON.parse(data) : []
  } catch (e) {
    console.error('Failed to load habits', e)
    return []
  }
}

export const saveHabits = (habits: Habit[]): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(habits))
  } catch (e) {
    console.error('Failed to save habits', e)
  }
}
